import { GlobalStateType } from '@modules/global/state';

export type FingerPrintAntiFraudType = {
  user_deviceid: string;
  user_user_agent: string;
  user_time_zone: number;
  user_language: string;
  user_platform: string;
};

export default (fingerPrint: GlobalStateType['fingerPrintData']): FingerPrintAntiFraudType => ({
  user_deviceid: fingerPrint?.deviceId,
  user_user_agent: navigator.userAgent,
  user_time_zone: new Date().getTimezoneOffset(),
  user_language: fingerPrint?.languages?.[0]?.[0],
  user_platform: fingerPrint?.platform,
});
